import { TTripDestination } from "../TripDestinations"

export interface IDocType {
	id: number
	name: string
	destinations?: TTripDestination[]
	deleted_at?: null | string
}

export const supportedDocumentTypes = [
	"image/png",
	"image/jpg",
	"image/jpeg",
	"application/pdf",
]
